module.exports = __webpack_public_path__ + "static/media/progress_bar_stats.e65b3bd0.svg";